// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"qx_a bic_sw bic_kx bic_ky","PostDetailRight__brandDaysPosts":"qx_b bic_sw bic_kx bic_ky"};